import { Epic } from 'interfaces/middleware'
import { PARTIAL_COMPLETE_FUTURE_LAYER, partialCompleteFutureLayerActionCreator } from 'components/features/future/actions'
import { mergeMap } from 'rxjs/operators'
import { empty, of } from 'rxjs'
import { layerSelector } from 'components/features/future/selectors'
import { FUTURE_LAYER_URL } from 'interfaces/ajax'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { normalizeFutureResponse } from 'components/features/future/helpers'
import { catchAjaxSafe } from 'rxOperators/catchSafe'

export const partialCompleteEpic: Epic = (action$, store, { patch }) =>
  action$.pipe(
    filterRequestOfType(PARTIAL_COMPLETE_FUTURE_LAYER, 'request'),
    mergeMap((action) => {
      const { params } = action.payload
      const state = store.getState()
      const layer = layerSelector(state, params)
      if (!layer) {
        return empty()
      }

      const { slug, uid } = layer

      const url = {
        url: FUTURE_LAYER_URL,
        params: {
          slug,
          uid,
        },
      }

      return patch(url, { body: {
        status: 'partially_completed' as const,
        slug,
        uid,
      }}).pipe(
        mergeMap(({ response }) => {
          return of(partialCompleteFutureLayerActionCreator.success(params, normalizeFutureResponse(response)))
        }),
        catchAjaxSafe((error) => {
          return of(partialCompleteFutureLayerActionCreator.fail(params, error.status))
        })
      )
    }),
  )
